import React from "react"
import { createIcon } from "@chakra-ui/icons"

export const Email = createIcon({
  displayName: "Email",
  viewBox: "0 0 24 24",
  defaultProps: {
    role: "img",
  },
  path: (
    <>
      <title> Email Icon</title>
      <path
        fill="currentColor"
        d="M19.3 6H4.5C3.7 6 3 6.7 3 7.5V17.2C3 18 3.7 18.7 4.5 18.7H19.4C20.2 18.7 20.9 18 20.9 17.2V7.5C20.8 6.6 20.2 6 19.3 6ZM4 7.6L8.8 12.3L4 17V7.6ZM12.3 13.6C12.1 13.8 11.8 13.8 11.6 13.6L9.9 12L4.8 7H19.2L12.3 13.6ZM9.5 13L10.9 14.3C11.2 14.6 11.6 14.7 12 14.7C12.4 14.7 12.8 14.6 13 14.3L14.4 12.9L19.2 17.6H4.7L9.5 13ZM15.1 12.3L19.9 7.6V17L15.1 12.3Z"
      />
    </>
  ),
})
